import { render, staticRenderFns } from "./SelfTestsList.vue?vue&type=template&id=45f139b5&scoped=true&"
import script from "./SelfTestsList.vue?vue&type=script&lang=js&"
export * from "./SelfTestsList.vue?vue&type=script&lang=js&"
import style0 from "./SelfTestsList.vue?vue&type=style&index=0&id=45f139b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f139b5",
  null
  
)

export default component.exports